import {useState, useEffect} from '@wordpress/element';
import {Icon} from '@wordpress/components';
import {
    ConnectComponentsProvider,
    loadConnectAndInitialize,
    ConnectPayments
} from '@stripe/react-connect-js';

import Navmenu from '../components/navmenu';
import Header from '../components/header';
import ConnectNotice from "../components/connect-notice";

export const Dashboard = ({data}) => {
    const {i18n} = data;
    const [activeItem, setActiveItem] = useState('dashboard');
    const [connectInstance, setConnectInstance] = useState(null);

    const navItems = [
        {
            name: 'dashboard',
            label: 'Dashboard',
            link: data.links.dashboard,
            icon: <Icon icon="screenoptions"/>,
        },
        {
            name: 'settings',
            label: 'Settings',
            link: data.links.settings,
            icon: <Icon icon="admin-generic"/>,
        },
        {
            name: 'documentation',
            label: 'Documentation',
            link: data.links.documentation,
            icon: <Icon icon="media-document"/>,
        },
        {
            name: 'support',
            label: 'Support',
            link: data.links.support,
            icon: <Icon icon="editor-help"/>,
        },
    ];

    return (
        <div className="dashboard-container">
            <div>
                <Header
                    title={i18n.title}
                    notice={i18n.notConnected}
                    modeText={i18n.modeText}
                    mode={data.mode}
                    isConnected={data.isConnected}
                    accountId={data.accountId}>
                    <Navmenu
                        items={navItems}
                        activeItem={activeItem}
                        onSelect={(item) => setActiveItem(item.name)}
                    />
                </Header>
                <div>
                    <ConnectNotice i18n={data.i18n} links={data.links}/>
                </div>
            </div>
            <div>

            </div>
        </div>
    );
};

export default Dashboard;